<template>
  <!-- One drop-down option in its colour and icon (US 9398) -->
  <span class="op-pill" :style="{ '--c': style.hex, '--t': style.text }">
    <font-awesome-icon :icon="style.icon"/>{{ option.title }}
  </span>
</template>

<script>
  import { optionStyle } from '@/util/dropdownOptions.js';

  export default {
    name: 'OptionPill',
    props: {
      option: {
        type: Object,
        required: true
      }
    },
    computed: {
      style() {
        return optionStyle(this.option);
      }
    }
  }
</script>
